export default __webpack_public_path__ + "static/media/feature.b834b864.png";